import * as Sentry from "@sentry/browser";

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_JS_DNS,
    environment: import.meta.env.VITE_APP_ENV,
    sendDefaultPii: true,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.browserProfilingIntegration(),
        Sentry.replayIntegration({
            maskAllText: false,
        }),
    ],
    tracesSampleRate: 0.1,
    profilesSampleRate: 0.1,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
});

import './bootstrap'
import hljs from 'highlight.js/lib/common'
import 'highlight.js/styles/github-dark.css'
import CopyButtonPlugin from 'highlightjs-copy'
import 'highlightjs-copy/dist/highlightjs-copy.min.css'
import './darkmode'
import { initFlowbite } from 'flowbite';
import './speech-to-text'

document.addEventListener("initiateGenerateResponse", (event) => {
    let loader = "<div class='loader little mt-4 ml-4 mb-4'></div>";
    const imageGeneration = event.detail[0].image_generation;
    if (imageGeneration) {
        loader =
            "<div class='flex justify-start space-x-2 items-center'><div class='loader little mt-4 ml-4 mb-4'></div><p class='text-sm text-gray-500'>Generating image...</p>";
    }
    const messagesContainer = document.getElementById("messages-container");
    if (messagesContainer) {
        messagesContainer.insertAdjacentHTML("beforeend", loader);
    }

    setTimeout(function () {
        Livewire.dispatch("executeGenerateResponse");
    }, 300);
});

document.addEventListener('lightbox-open', (event) => {
    const rootEl = document.querySelector('[x-data]');
    if (rootEl && rootEl.__x) {
        const {
            lightboxInstance
        } = rootEl.__x.$data;
        if (lightboxInstance) {
            lightboxInstance.images = event.detail.images;
            lightboxInstance.open(event.detail.index);
        }
    }
});



document.addEventListener("alpine:init", (event) => {
    document.addEventListener("click", function (event) {
        const elClasses = event.target.classList;
        if (document.querySelector("#messages-container")) {
            if (
                (elClasses.contains("reprompt-button") &&
                    Alpine.store("reprompt").opened == null) ||
                !elClasses.contains("reprompt-button")
            ) {
                Alpine.store("reprompt").opened = null;
            }
        }
    });
});

// Triggered as the final step of any page navigation...
// Also triggered on page-load instead of "DOMContentLoaded"...
document.addEventListener("livewire:navigated", () => {
    if (window.User) {
        Sentry.setUser({
            id: window.User.id,
            email: window.User.email,
            username: window.User.name,
        });
    }

    initFlowbite();
    document.querySelectorAll(".file-input-button").forEach((el) => {
        el.addEventListener("click", (e) => {
            e.preventDefault();
            el.closest("div").querySelector(".file-input").click();
        });
    });

    window.highlightNewMessage = () => {
        setTimeout(() => {
            hljs.addPlugin(new CopyButtonPlugin());
            hljs.highlightAll();
        }, 100);
    };

    window.highlightNewMessage();

    // Add event listener for highlightNewMessage
    document.addEventListener("highlightNewMessage", () => {
        window.highlightNewMessage();
    });

    window.isOpen = false;

    document.addEventListener("close-actions-list", function () {
        window.isOpen = true;

        handleTransition();
    });

    if (document.querySelector(".trigger-transition")) {
        const triggerTransition = document.querySelector(".trigger-transition");

        triggerTransition.addEventListener("mouseenter", function () {
            handleTransition();
        });

        document.addEventListener("model-changed", function () {
            hideOptionMenu();
        });
    }

    function handleTransition() {
        if (!window.isOpen) {
            window.isOpen = true;
            let animation_begin = false;
            var applyTransition =
                document.querySelectorAll(".apply-transition");

            const fixedElementsList = Array.from(
                document.querySelectorAll("*")
            ).filter((el) =>
                Array.from(el.classList).some((cls) => cls.startsWith("fixed-"))
            );

            // Calculate total width of fixed elements
            let totalFixedWidth = 0;
            fixedElementsList.forEach((el) => {
                totalFixedWidth += el.offsetWidth;
            });
            totalFixedWidth += 6;

            applyTransition.forEach((el, index) => {
                setTimeout(() => {
                    if (fixedElementsList && fixedElementsList.length > 0) {
                        // Use the total width of fixed elements plus spacing for each element
                        el.style.transform =
                            "translateX(" +
                            (totalFixedWidth + (index + 1) * 43) +
                            "px)";
                    } else {
                        el.style.transform =
                            "translateX(" + (index + 1) * 43 + "px)";
                    }
                    el.classList.remove("transition-transform");
                    animation_begin = true;
                }, index * 100);
            });

            // Si pendant plus de 5 secondes, on a pas la souris sur apply-transition ou .trigger-transition, on appelle la fonction hideOptionMenu
            setTimeout(() => {
                if (
                    !document.querySelector(".apply-transition:hover") &&
                    !document.querySelector(".trigger-transition:hover")
                ) {
                    hideOptionMenu();
                }
            }, 2000);
        } else {
            hideOptionMenu();
        }
    }

    function hideOptionMenu() {
        var applyTransition = document.querySelectorAll(".apply-transition");
        applyTransition.forEach((el, index) => {
            el.classList.add("transition-transform");
            el.style.transform = "translateX(0)";
        });
        window.isOpen = false;
    }

    if (document.documentElement.classList.contains("dark")) {
        document
            .querySelectorAll(".remove-backgroundColor-after-load")
            .forEach((el) => {
                el.style.removeProperty("background-color");
            });
    }
    dynamicStyleRemove();
});

window.onload = function () {
    dynamicStyleRemove();
};

function dynamicStyleRemove() {
    document
        .querySelectorAll("[class*='remove-'][class*='-after-load']")
        .forEach((el) => {
            el.classList.forEach((cls) => {
                const match = cls.match(/^remove-(.+?)-after-load$/);
                if (match) {
                    const property = match[1];
                    if (property === "style") {
                        el.removeAttribute("style");
                    } else {
                        el.style.removeProperty(property);
                    }
                }
            });
        });
}
